import { render } from "./LabeledContainer.vue?vue&type=template&id=45a8b996&scoped=true"
import script from "./LabeledContainer.vue?vue&type=script&lang=js"
export * from "./LabeledContainer.vue?vue&type=script&lang=js"

import "./LabeledContainer.vue?vue&type=style&index=0&id=45a8b996&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-45a8b996"

export default script